export enum DonorAction {
    '- select -' = 0,
    Update = 1,
    Delete = 2,
}